import { CampaignReminderAction } from 'lib/actions/access_review'
import { GetSendReminderPreview, SendReminder } from 'lib/actions/task'
import { User } from 'pbts/c1/api/user/v1/user'

export const closeAction = 'closeAction'
export type CloseAction = {
    type: 'closeAction'
}
export const updateUserAction = 'updateUserAction'
export type UpdateCopiedUsers = {
    type: 'updateUserAction'
    users: User[]
}
export const notifyManagerAction = 'notifyManagerAction'
export type NotifyManager = {
    type: 'notifyManagerAction'
    value: boolean
}
export const ccOthersAction = 'ccOthersAction'
export type CcOthers = {
    type: 'ccOthersAction'
    value: boolean
}
export const messageChangedAction = 'messageChangedAction'
export type MessageChangedAction = {
    type: 'messageChangedAction'
    message: string
}

export type sendRemindersAction =
    | GetSendReminderPreview
    | SendReminder
    | CampaignReminderAction
    | CloseAction
    | UpdateCopiedUsers
    | NotifyManager
    | CcOthers
    | MessageChangedAction
